/**
 *
 * Created by neo on 18.01.17.
 */

import { makeAutoObservable } from 'mobx';
import { LocalizedValue, createLocalizedValue } from './LocalizedValue';
import { LocalizedNamedEntity, createLocalizedNamedEntity } from './LocalizedNamedEntity';
import { languageState } from '../Contexts/LanguageContext';

export const languagePriority = ['de', 'en', 'fr', 'it'];

// Observable model type
export type LocalizedEntity = LocalizedNamedEntity & {
  description: LocalizedValue[];
  readonly translatedDescription: string;
  changeDescription(lang: string, value: string): void;
  getDescription(lang: string): string;
};

// Helper to create localized entity fields (for composition in other factories)
export function createLocalizedEntityFields(json?: Partial<LocalizedEntity>): LocalizedEntity {
  const base = createLocalizedNamedEntity(json);

  return {
    ...base,
    description: (json?.description || []).map((l) => createLocalizedValue(l)),

    get translatedDescription(): string {
      const language = languageState.language;
      const langFit = this.description.find((n) => n.lang === language.toLowerCase())?.value;

      if (langFit?.trim()) {
        return langFit;
      }

      for (const lang of languagePriority) {
        const entry = this.description.find((l) => l.lang === lang);
        if (entry) {
          return entry.value ?? '';
        }
      }
      const first = this.description[0];
      return first?.value ?? '';
    },

    changeDescription(lang: string, value: string) {
      const existing = this.description.find((n) => n.lang === lang.toLowerCase());
      if (existing) {
        existing.value = value;
      } else {
        this.description.push(createLocalizedValue({ lang: lang.toLowerCase(), value }));
      }
    },

    getDescription(lang: string): string {
      return this.description.find((n) => n.lang === lang.toLowerCase())?.value || this.translatedDescription;
    },
  };
}

// Factory function
export function createLocalizedEntity(json?: Partial<LocalizedEntity>): LocalizedEntity {
  const base = createLocalizedNamedEntity(json);

  return makeAutoObservable({
    ...base,
    description: (json?.description || []).map((l) => createLocalizedValue(l)),

    get translatedDescription(): string {
      const language = languageState.language;
      const langFit = this.description.find((n) => n.lang === language.toLowerCase())?.value;

      if (langFit?.trim()) {
        return langFit;
      }

      for (const lang of languagePriority) {
        const entry = this.description.find((l) => l.lang === lang);
        if (entry) {
          return entry.value ?? '';
        }
      }
      const first = this.description[0];
      return first?.value ?? '';
    },

    changeDescription(lang: string, value: string) {
      const existing = this.description.find((n) => n.lang === lang.toLowerCase());
      if (existing) {
        existing.value = value;
      } else {
        this.description.push(createLocalizedValue({ lang: lang.toLowerCase(), value }));
      }
    },

    getDescription(lang: string): string {
      return this.description.find((n) => n.lang === lang.toLowerCase())?.value || this.translatedDescription;
    },
  });
}
